import { useState } from "react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { apiSetSubmitStage } from "utils/API/TrxNowAPI";
import { Header, PaginationHelper, TitleBar } from "webapp/components";
import { AppState } from "webapp/enums/AppState";
import { EFGMemberSearchForm } from "webapp/components/Partner/EFG/EFGMemberSearchForm";
import { devLog } from "utils/devLog";

export default function EFGMemberSearch(props) {
  const { t } = useTranslation();
  const formRef = useRef();

  const [firstName, setFirstName] = useState(props.context?.MemberLookup?.firstName || props.context?.FirstName || "");

  const [lastName, setLastName] = useState(props.context?.MemberLookup?.lastName || props.context?.LastName || "");

  const [phoneNumber, setPhoneNumber] = useState(props.context?.MemberLookup?.phone || props.context?.Number || "");

  const [last8Vin, setLast8Vin] = useState(props.context?.MemberLookup?.last8Vin || props.context?.last8Vin || "");

  const [memberNumber, setMemberNumber] = useState(
    props.context?.MemberLookup?.memberNumber || props.context?.memberNumber || "",
  );

  const [searchType, setSearchType] = useState(
    props.context?.MemberLookup?.searchType || props.context?.searchType || "",
  );

  const onUserBack = () => {
    if (typeof props.onUserBack === "function") {
      props.onUserBack();
    }
  };

  const onUserNext = () => {
    devLog("formRef", formRef);
    if (typeof formRef.onUserNext === "function") {
      formRef.current.submit();
    }
  };

  const onUserCancel = () => {
    if (typeof props.onUserCancel === "function") {
      props.onUserCancel();
    }
  };

  const onFormLoad = (ref) => {
    devLog("onFormLoad", formRef, ref);
    formRef.current = ref;
    devLog("onFormLoad", formRef);
  };

  const onFormUpdate = (data) => {
    devLog("onFormUpdate", data);
    if (typeof data === "object") {
      if (typeof data.firstName === "string") {
        setFirstName(data.firstName);
      }
      if (typeof data.lastName === "string") {
        setLastName(data.lastName);
      }
      if (typeof data.last8Vin === "string") {
        setLast8Vin(data.last8Vin);
      }
      if (typeof data.memberNumber === "string") {
        setMemberNumber(data.memberNumber);
      }
      if (typeof data.phoneNumber === "string") {
        setPhoneNumber(data.phoneNumber);
      }
      if (typeof data.searchType === "string") {
        setSearchType(data.searchType);
      }
    }
  };

  const onFormSubmit = (data) => {
    const context = props.context;
    const naviState = context.state.navigationService.getState(AppState.MemberSearch);
    devLog("ContractSearch", naviState);
    onFormUpdate(data);
    const nextState =
      naviState && typeof naviState.nextState === "number" ? naviState.nextState : AppState.ConfirmVehicle;
    context.setState(
      {
        webAppState: nextState,
        MemberLookup: {
          firstName: data.firstName,
          lastName: data.lastName,
          last8Vin: data.last8Vin,
          phoneNumber: data.phoneNumber,
          memberNumber: data.memberNumber,
          searchType: data.searchType,
        },
      },
      () => {
        apiSetSubmitStage(
          context.state,
          nextState,
          context.state.DisablementAddress || "DisablementAddress Not Available",
        );
        context.saveWebAppState(context);
      },
    );
  };

  const LocateUserObj = {
    img: props.logo,
    fragment: (
      <>
        <p className="mb-0">
          <strong>{t("FIMC.ContractSearch.TitleBar2")}</strong>
          <br />
        </p>
      </>
    ),
  };

  return (
    <div>
      <Header currState={props.currState} onUserBack={onUserBack} information={t("BWC.ContractSearch.TitleBar1")} />
      <TitleBar data={LocateUserObj} />
      <PaginationHelper context={props.context} />
      <EFGMemberSearchForm
        onFormUpdate={onFormUpdate}
        onFormLoad={onFormLoad}
        onFormSubmit={onFormSubmit}
        onUserCancel={onUserCancel}
        onNextClick={onUserNext}
        currState={props.currState}
      />
    </div>
  );
}
